import React from 'react';
import { CheckIcon, ExternalLinkIcon } from 'lucide-react';
import { adminPoints, bookingPoints, bookingSteps, demo, shots } from '../../data/offer';
import { Section } from './Section';
export function Product() {
  return <>
      <Section index="02" label="De website" title="De website" data-id="element-52" data-mp="1fclmiuap1234">
        <figure className="overflow-hidden rounded-xl border border-line bg-surface" data-id="element-53" data-mp="1afv8sdmd2ikv">
          <img src={shots.site} alt="Homepage van de demo-website" className="w-full" loading="lazy" data-id="element-54" data-mp="15fpfkt0g0o0o" />
        </figure>
        <a href={demo.site} target="_blank" rel="noreferrer" className="mt-5 inline-flex items-center gap-2 rounded-full border border-line px-4 py-2 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-white/30 hover:bg-white/5" data-id="element-55" data-mp="10nfq1e38ppyx">
          dailycc.dstrct.website
          <ExternalLinkIcon className="h-4 w-4" aria-hidden="true" data-id="element-56" data-mp="hrfxa12fuiea" />
        </a>
      </Section>

      <Section index="03" label="Boekingsflow" title="Vier stappen, onder de minuut" data-id="element-57" data-mp="26afcsfstomt9">
        <figure className="overflow-hidden rounded-xl border border-line bg-surface" data-id="element-58" data-mp="2b2q8f6gj5mg0">
          <img src={shots.booking} alt="Stap 1 van de boekingsflow: behandeling en extra’s kiezen" className="w-full" loading="lazy" data-id="element-59" data-mp="1xb21dhl51o5w" />
        </figure>

        <ol className="mt-8 grid gap-6 md:grid-cols-4" data-id="element-60" data-mp="2pyxru4k46ju8">
          {bookingSteps.map(item => <li key={item.step} className="border-t border-line pt-4" data-id="element-61" data-mp="2u1kocirqcsxr">
              <span className="text-xs font-semibold tabular-nums text-accent" data-id="element-62" data-mp="2g19ztmdw7qfr">
                {item.step}
              </span>
              <h3 className="mt-2 text-base font-semibold tracking-tight text-white" data-id="element-63" data-mp="2kzl9nx46u0xz">
                {item.title}
              </h3>
              <p className="mt-1 text-sm leading-relaxed text-white/55" data-id="element-64" data-mp="14kjq3ta9gghe">
                {item.text}
              </p>
            </li>)}
        </ol>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-65" data-mp="pjmkk19xocye">
          {bookingPoints.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-white/75" data-id="element-66" data-mp="lgzsbz9coq0o">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-67" data-mp="gqj9fzmrgc6x" />
              <span data-id="element-68" data-mp="bry9807idsih">{item}</span>
            </li>)}
        </ul>
      </Section>

      <Section index="04" label="Beheeromgeving" title="Agenda, boekingen en omzet" data-id="element-69" data-mp="6slqnrno77lp">
        <figure className="overflow-hidden rounded-xl border border-line bg-surface" data-id="element-70" data-mp="6q8xsjgdjctv">
          <img src={shots.dashboard} alt="Dashboard van de beheeromgeving met omzet, aanvragen en boekingen" className="w-full" loading="lazy" data-id="element-71" data-mp="1s7hu7e8vtmm" />
        </figure>

        <div className="mt-4 grid gap-4 lg:grid-cols-12" data-id="element-72" data-mp="1s5y7z7umbc45">
          <figure className="overflow-hidden rounded-xl border border-line bg-surface lg:col-span-7" data-id="element-73" data-mp="1s5g2rlpz9nk3">
            <img src={shots.agenda} alt="Maandagenda met afspraken per dag" className="w-full" loading="lazy" data-id="element-74" data-mp="1n7eiwykq9k7k" />
          </figure>
          <figure className="overflow-hidden rounded-xl border border-line bg-surface lg:col-span-5" data-id="element-75" data-mp="1znwd705ro11k">
            <img src={shots.bookingDetail} alt="Detailpaneel van een boeking met status, prijs en acties" className="h-full w-full object-cover object-right" loading="lazy" data-id="element-76" data-mp="24gpipq927dep" />
          </figure>
        </div>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-77" data-mp="1gro5zqt71g3m">
          {adminPoints.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-white/75" data-id="element-78" data-mp="1lomxe1lh38y4">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-79" data-mp="1prjlu8xp1z9z" />
              <span data-id="element-80" data-mp="2x5eed9rciqj2">{item}</span>
            </li>)}
        </ul>
      </Section>
    </>;
}